import React, { useRef } from 'react';
import './MessageReactionBar.css';

const QUICK_REACTIONS = ['👍', '🔥', '💯'];

interface MessageReactionBarProps {
  onQuickReact: (emoji: string) => void;
  onOpenPicker: (buttonRef: React.RefObject<HTMLButtonElement | null>) => void;
}

export const MessageReactionBar: React.FC<MessageReactionBarProps> = ({
  onQuickReact,
  onOpenPicker,
}) => {
  const moreButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="message-reaction-bar">
      {QUICK_REACTIONS.map((emoji) => (
        <button
          key={emoji}
          className="reaction-bar-btn"
          onClick={(e) => {
            e.stopPropagation();
            onQuickReact(emoji);
          }}
          type="button"
          title={`React with ${emoji}`}
        >
          {emoji}
        </button>
      ))}
      <span className="reaction-bar-divider" />
      <button
        ref={moreButtonRef}
        className="reaction-bar-btn reaction-bar-more"
        onClick={(e) => {
          e.stopPropagation();
          onOpenPicker(moreButtonRef);
        }}
        type="button"
        title="More reactions"
      >
        &#x22EF;
      </button>
    </div>
  );
};
